import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';
import Objective from './objective';
import PlanPeriod from './plan-period';
import Organization from './organization';
import Activities from './activities';
import Person from './person';
import WorkType from './work-group';
import ReportSchedule from './report-schedule';
import Report from './report';
import DraftPeriod from './draft-period';
import ReportCompliance from './report-compliance';
import Version from './version';
import Projects from './projects';
import AnnualPlanWindow from './annual-plan-window';
/* jhipster-needle-add-route-import - JHipster will add routes here */

export default () => {
  return (
    <div>
      <ErrorBoundaryRoutes>
        {/* prettier-ignore */}
        <Route path="organization/*" element={<Organization />} />
        <Route path="activities/*" element={<Activities />} />
        <Route path="persons/*" element={<Person />} />
        <Route path="objective/*" element={<Objective />} />
        <Route path="plan-period/*" element={<PlanPeriod />} />
        <Route path="draft-period/*" element={<DraftPeriod />} />
        <Route path="work-type/*" element={<WorkType />} />
        <Route path="report-schedule/*" element={<ReportSchedule />} />
        <Route path="annual-plan-window/*" element={<AnnualPlanWindow />} />
        <Route path="reports/*" element={<Report />} />
        <Route path="report-compliance/*" element={<ReportCompliance />} />
        <Route path="version" element={<Version />} />
        <Route path="projects/*" element={<Projects />} />
        {/* jhipster-needle-add-route-path - JHipster will add routes here */}
      </ErrorBoundaryRoutes>
    </div>
  );
};
